import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppFlowService } from 'ClientApp/src/app/shared/services/app-flow/app-flow.service';
import { appConfig, clientConfig } from "../../../shared/constant/app.constant";
import { NavButton } from "./../../../shared/components/navigation/next-button.component";
import { Store, select } from "@ngrx/store";
import { take } from 'rxjs/operators';
import { ThemeService } from 'ClientApp/src/app/shared/theme/theme.service';

@Component({
  selector: 'app-customer-service-case',
  templateUrl: './customer-service-case.component.html',
  styleUrls: ['./customer-service-case.component.scss']
})
export class CustomerServiceCaseComponent implements OnInit,OnDestroy {

  banner_src:any = clientConfig.BANNER_JPG;
  returnNeeded: boolean = false;
  customerServiceNeeded: boolean = false;
  noReturnNeeded: boolean = false;
  showCustomerServicePage: boolean = false;
  showThankYouPage: boolean = false;
  subscription:any;

  screenNav: NavButton = {
    buttonText: "labelprint",
    cssClass: "back-btn",
    number: 4,
  };

  constructor( private appFlowService: AppFlowService,private activatedRoute: ActivatedRoute,  private store: Store<AppState>,private themeService: ThemeService ) 
  {
    if(clientConfig.APPFLOW === "formPostOrderB2CTechSupportFlow")
    {
      this.appFlowService.activeStepId = this.screenNav.number + 1;
    }
    else
    this.appFlowService.activeStepId = this.screenNav.number;
    console.log(this.activatedRoute.snapshot.data.techSupportResponse)

    this.store.pipe(select("techSupport")).pipe(take(1)).subscribe((items) => {
      this.returnNeeded = items.returnNeeded;
      this.customerServiceNeeded = items.customerServiceNeeded;
      this.noReturnNeeded = items.noReturnNeeded;
    });

    if(this.customerServiceNeeded && !this.returnNeeded)
    {
      this.showCustomerServicePage = true;
    }
    else if(this.noReturnNeeded && !this.customerServiceNeeded && !this.returnNeeded)
    {
      this.showThankYouPage = true;
    }
  }

  ngOnInit(){
    if (clientConfig.MERCHANTCONFIG_IN_DB && clientConfig.MERCHANTCONFIG_IN_DB.toLowerCase().trim() === "true") {
      this.subscription=this.themeService.banner$.subscribe(banner => {
          this.banner_src = banner.data
      });
    }
  }

  ngOnDestroy(){
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  handleImageError(event:any,imageElement: HTMLImageElement)
  {
    if (event.target.dataset.errorHandled) {
      return;
    }
      // Handle the error, set a fallback image
      if (clientConfig.MERCHANTNAME.toLowerCase().includes("sony")) 
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/sonyBanner.jpg`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("schneider"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/schneiderBanner.jpg`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("starlink"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/starlinkBanner.jpg`;
      else
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/sonyBanner.jpg`;

        event.target.dataset.errorHandled = 'true';
  }

}
